export const StarredModule = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setFileList(state, files) {
          state.fileList = files;
        },
        resetState(state) {
          Object.assign(state, getDefaultState());
        }
    }
}

function getDefaultState() {
    return {
        loadFolderData: 1,
        tableFolderLoader: 1,
        tableFileLoader: 1,
        reLoadFolder: 1,
        reLoadPathFolder: 1,
        currentPage: 1,
        totalPages: 1,
        currentFolderPage: 1,
        totalFolderPages: 1,
        removeFolderStarrd: 1,
        folderList: [],
        fileList: [],
    };
}